import { NotFound } from 'component/errors/not-found';
import { articleModuleQuery, useModule } from 'system/structure-modules';
import { useEnabledFeatures } from 'util/features-hooks';

export default function ArticleManagePositionScreen() {
    const { TeaserPositionScreen } = useModule(articleModuleQuery);
    const { positionteaser } = useEnabledFeatures();
    if (!positionteaser) {
        return <NotFound />;
    }

    return <TeaserPositionScreen />;
}
